export default {
  AUTO: 'auto',
  AUTO_LEFT: 'auto-left',
  AUTO_RIGHT: 'auto-right',
  BOTTOM: 'bottom',
  BOTTOM_END: 'bottom-end',
  BOTTOM_START: 'bottom-start',
  LEFT: 'left',
  LEFT_END: 'left-end',
  LEFT_START: 'left-start',
  RIGHT: 'right',
  RIGHT_END: 'right-end',
  RIGHT_START: 'right-start',
  TOP: 'top',
  TOP_END: 'top-end',
  TOP_START: 'top-start',
};
